import {Box, useBreakpointValue} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import {useCommerceAPI} from '../../commerce-api/contexts'
import useAsync from '../../commerce-api/hooks/useAsync'
import {Skeleton as AddToCartSkeleton} from '../../components/add-to-cart-cta'
import WidgetArticleDefaultViewMobile from './widget-article-default-view-mobile'
import WidgetArticleDefaultViewDesktop from './widget-article-default-view-desktop'
import WidgetArticleGridView from './widget-article-grid-view'

/**
 * Display items from content_search
 *
 * @param {string} folder - folder name
 * @param {string} count - number of results
 * @param {string} type - default or grid, defines which layout is choosen
 * @param {string} q - searchquery
 * @param {string} showLoadMore - show or hide "load more" button, only effects if type=grid
 *
 * @example
 *   <pwa-widget-article folder=stokke-stories" count={3} type="default">
 *     $include(...)$
 *   </pwa-widget-article>
 */
const WidgetArticle = ({folder, q, type, count: countStr, showLoadMore: showLoadMoreStr}) => {
    const count = Number.parseInt(countStr, 10)
    const showLoadMore = showLoadMoreStr && showLoadMoreStr !== 'false'
    const api = useCommerceAPI()
    const smallOrBigView = useBreakpointValue({base: 'small', lg: 'big'})
    const [moreResultsLink, setMoreResultsLink] = useState(null)
    const [sliderData, setSliderData] = useState(null)

    const {execute, loading, data} = useAsync(api.contentSearch.getSearchResult)

    useEffect(() => {
        if (data) {
            setSliderData(data.hits)
            setMoreResultsLink(data.next)
        }
    }, [data])

    useEffect(() => {
        execute({
            parameters: {
                queryString: q,
                fdid: folder,
                count: count,
                ...(folder && {sortAttribute: 'storiesPriority'})
            }
        })
    }, [count, execute, folder, q])

    return (
        <Box>
            {loading && <AddToCartSkeleton />}
            {!loading && !!sliderData && sliderData.length > 1 && (
                <>
                    {type === 'grid' ? (
                        <WidgetArticleGridView
                            sliderData={sliderData}
                            showLoadMore={showLoadMore}
                            moreResultsLink={moreResultsLink}
                        />
                    ) : (
                        <Box data-testid="default-element">
                            {smallOrBigView === 'small' ? (
                                <WidgetArticleDefaultViewMobile sliderData={sliderData} />
                            ) : (
                                <WidgetArticleDefaultViewDesktop sliderData={sliderData} />
                            )}
                        </Box>
                    )}
                </>
            )}
        </Box>
    )
}

WidgetArticle.propTypes = {
    folder: PropTypes.string,
    q: PropTypes.string,
    type: PropTypes.string,
    count: PropTypes.string,
    showLoadMore: PropTypes.string
}

export default WidgetArticle
